import { fetchData } from '../utils/fetchData';
import { RESOURCES, API_BASE_URL } from '../utils/constants/constants';

const INDICATORS_RESOURCES = RESOURCES.indicators;

export default function getAvailableIndicators() {
  const resource = `${API_BASE_URL}${INDICATORS_RESOURCES.availableIndicators}`;
  return fetchData(resource);
}
